import { createSharedComposable } from '@vueuse/core'
import { computed, onScopeDispose, shallowRef } from 'vue'

const useStack = createSharedComposable(() => shallowRef<symbol[]>([]))

export function useOverlayStack() {
  const stack = useStack()
  const id = Symbol('overlay')
  const index = computed(() => stack.value.indexOf(id))
  const active = computed(() => index.value !== -1)
  const isTopmost = computed(() => active.value && stack.value.at(-1) === id)

  function activate() {
    stack.value = [...stack.value.filter(entry => entry !== id), id]
  }

  function deactivate() {
    stack.value = stack.value.filter(entry => entry !== id)
  }

  onScopeDispose(deactivate)

  return { index, active, isTopmost, activate, deactivate }
}
